export default "__VITE_ASSET__DYwLPcyI__"